module.exports = __webpack_public_path__ + "static/media/phone.cfb1388f.png";